import axios from 'axios'

const API_PATH = 'api/v2/admins/settings'

const LegacySettingsResourcesApiV2 = {
  get: async (resource, archived = false) => axios.get(`${API_PATH}/${resource}`, { params: { archived: String(archived) } }),

  show: async (resource, id) => axios.get(`${API_PATH}/${resource}/${id}`),

  create: async (resource, payload, useFormData = false) => (
    axios.post(
      `${API_PATH}/${resource}`,
      payload,
      useFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined
    )
  ),

  update: async (resource, id, payload, useFormData = false) => (
    axios.patch(
      `${API_PATH}/${resource}/${id}`,
      payload,
      useFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined
    )
  ),

  restore: async (resource, id) => axios.post(`${API_PATH}/${resource}/${id}/restore`),

  destroy: async (resource, id) => axios.delete(`${API_PATH}/${resource}/${id}`)
}

export default LegacySettingsResourcesApiV2
